export default {
  infosKey: 'Info key',
};
